export default __webpack_public_path__ + "static/media/Die_6.0db96c00.png";